import React from 'react'
import Card from 'react-bootstrap/Card'

/** Holder shape coming from your SelectEntry builders */
export type HolderItem = {
    range: number | string              // numeric percentage OR class name
    content: React.ReactNode            // inner content you already render (title + time)
    color: string                       // bg color
    tcolor: string                      // text color
    on_Click?: (desc?: any) => void     // optional click handler
    description?: any                   // payload for on_Click
    title: string                       // hover: title
    date: string                        // hover: start datetime
    enddate: string                     // hover: end datetime
    total: string                       // hover: formatted total time
    hoverId: string                     // REQUIRED: unique id for hover Card (you build this already)
}

/** Local DOM-based toggler to mimic your previous toggleHover behavior */
const toggleById = (id: string, show: boolean) => {
    const el = document.getElementById(id) as HTMLDivElement | null
    if (el) el.style.display = show ? 'block' : 'none'
}

/** Core event box with full-box hover; no React state, DOM toggle by id */
const CalendarEventBox: React.FC<{
    item: HolderItem
    widthPct: number
    usePercentHeight: boolean
}> = ({ item, widthPct, usePercentHeight }) => {

    const styleBase: React.CSSProperties = {
        width: `${widthPct}%`,
        background: item.color,
        color: item.tcolor,
        position: 'relative',                       // anchor for absolute hover card
    }

    const style: React.CSSProperties =
        usePercentHeight && typeof item.range === 'number'
            ? { ...styleBase, height: `${item.range}%` } // percent height variant
            : styleBase                                   // class-based height variant

    const className =
        'event float-start' +
        (!usePercentHeight && typeof item.range === 'string' ? ` ${item.range}` : '')

    return (
        <div
            className={className}
            style={style}
            onMouseEnter={() => toggleById(item.hoverId, true)}   // FULL-BOX hover
            onMouseLeave={() => toggleById(item.hoverId, false)}
            onClick={() => (item.on_Click ? item.on_Click(item.description) : undefined)}
        >
            {/* keep your original structure */}
            <input id="check" type="checkbox" className="checkbox" />
            <label htmlFor="check" />
            {item.content}

            {/* identical hover card styling as in your Planer */}
            <Card
                id={item.hoverId}
                className="arrowBottom"
                style={{
                    width: '18rem',
                    position: 'fixed', // <- statt absolute!
                    top: 'calc(var(--mouse-y, 0px) - 160px)',
                    left: 'calc(var(--mouse-x, 0px) - 100px)',
                    display: 'none',
                    background: '#343232',
                    color: 'white',
                    pointerEvents: 'none' // prevents flicker; hover remains on the box
                }}
            >
                <Card.Body className="pb-1 pt-2">
                    <Card.Title>{item.title}</Card.Title>
                    <Card.Text>
                        <div><strong>{item.date}</strong></div>
                        <div><strong>{item.enddate}</strong></div>
                        <div><strong>{item.total}</strong></div>
                    </Card.Text>
                </Card.Body>
            </Card>
        </div>
    )
}

/** EXACT signature you use: percent-based height (Cases 0/1/5/6) */
export const renderEventWithHeight = (item: HolderItem, widthPct: number) => (
    <CalendarEventBox item={item} widthPct={widthPct} usePercentHeight={true} />
)

/** Class-based height (Cases 2/3/4: 'double', 'tripple', ...) */
export const renderEventWithClassRange = (item: HolderItem, widthPct: number) => (
    <CalendarEventBox item={item} widthPct={widthPct} usePercentHeight={false} />
)
